
import { startOfWeek, endOfWeek, startOfMonth, endOfMonth, startOfYear, endOfYear, subWeeks, subMonths, subYears } from 'date-fns';
import { PeriodBoundaries } from './types';
import { TimePeriod } from '../../types';

export const getBoundariesForPeriod = (period: TimePeriod, currentDate = new Date()): PeriodBoundaries => {
  let currentStart: Date;
  let currentEnd: Date = new Date();
  let previousStart: Date;
  let previousEnd: Date;

  switch(period) {
    case 'week':
      currentStart = startOfWeek(currentDate, { weekStartsOn: 1 });
      currentEnd = endOfWeek(currentDate, { weekStartsOn: 1 });
      previousStart = startOfWeek(subWeeks(currentDate, 1), { weekStartsOn: 1 });
      previousEnd = endOfWeek(subWeeks(currentDate, 1), { weekStartsOn: 1 });
      break;
    case 'month':
      currentStart = startOfMonth(currentDate);
      currentEnd = endOfMonth(currentDate);
      previousStart = startOfMonth(subMonths(currentDate, 1));
      previousEnd = endOfMonth(subMonths(currentDate, 1));
      break;
    case 'year':
      currentStart = startOfYear(currentDate);
      currentEnd = endOfYear(currentDate);
      previousStart = startOfYear(subYears(currentDate, 1));
      previousEnd = endOfYear(subYears(currentDate, 1));
      break;
    case 'all':
    default:
      // For 'all', use a very old date as start and current date as end
      currentStart = new Date(2000, 0, 1); // January 1, 2000
      currentEnd = new Date(); // Current date
      previousStart = new Date(1999, 0, 1); // January 1, 1999
      previousEnd = new Date(1999, 11, 31); // December 31, 1999
      break;
  }

  return {
    currentStart,
    currentEnd,
    previousStart,
    previousEnd
  };
};

// Alias for backward compatibility
export const getPeriodBoundaries = getBoundariesForPeriod;
